import { BookOpen, Info, Settings, UsersRound } from 'lucide-react'
import { LinkItem } from '../../../AppsList/LinkItem'
import { SideBarTitle } from '../../../../../common/components/side-bar/SideBarTitle'
import { FC } from 'react'
import { Group } from '@wellesley/openapi'
import { useSelector } from 'react-redux'
import { groupSlice, useGroupPermissions } from '@wellesley/group'
import { getRoute } from '@wellesley/router'

const size = 'lg'

type GroupGeneralProps = {
  group: Group
}

export const GroupGeneral: FC<GroupGeneralProps> = ({ group }) => {
  const rules = useSelector(groupSlice.selectors.selectRules)
  const showRules = !!rules?.length
  const { canManageGroupSettings } = useGroupPermissions(group.groupId)

  return (
    <>
      <SideBarTitle title="General" />
      {canManageGroupSettings && (
        <LinkItem
          title="Settings"
          Icon={Settings}
          size={size}
          link={getRoute('/g/:groupname/settings/:tab?', {
            groupname: group.groupName,
          })}
        />
      )}
      <LinkItem
        title="Members"
        Icon={UsersRound}
        size={size}
        link="/g/:groupname"
        props={{ groupname: group.groupName }}
        queryParams={{ modal: 'members' }}
      />
      <LinkItem
        title="About group"
        Icon={Info}
        size={size}
        link="/g/:groupname"
        props={{ groupname: group.groupName }}
        queryParams={{ modal: 'about' }}
      />
      {showRules && (
        <LinkItem
          title="Rules"
          Icon={BookOpen}
          size={size}
          link="/g/:groupname"
          props={{ groupname: group.groupName }}
          queryParams={{ modal: 'rules' }}
        />
      )}
    </>
  )
}
